import { SignInReqType, SignInResType } from '@src/types/auth';
import client from './client';

const authApi = {
  signIn: async (signInInfo: SignInReqType) => {
    const { data } = await client.post<SignInResType>('auth/signin', signInInfo);
    return data;
  },
  refreshAccessToken: async (email: string, token: string) => {
    const { data } = await client.post<{ access_token: string; refresh_token: string }>('auth/refresh_access_token', {
      email,
      token,
    });
    return data;
  },
};

export default authApi;
